export default function XSLT_Server() {
  return (
    <div>
      <h1>XSLT_Server</h1>
      <p>This is the XSLT_Server component.</p>
    </div>
  );
}